import GA from "./GA/GA";
import GroupOffer from "./GroupOffers/GroupOffer";
import Header2 from "./Header2";
import Investors from "./Investors/Investors";
import Partners from "./Partners/Partners";
import Startup from "./Startups/Startup";

const Bookings = () => {
  return (
    <div  >
      <Header2/>
{/* 
    <header class="MuiPaper-root MuiAppBar-root MuiAppBar-positionStatic MuiAppBar-colorPrimary jss18 MuiPaper-elevation4">
      <div class="MuiGrid-root jss21 MuiGrid-container MuiGrid-wrap-xs-nowrap">
        <div class="MuiTabs-root jss19">
          <div
            style={{width:"99px",height:"99px", position:"absolute",top:"-9999px",overflow:"scroll"}}
            class="MuiTabs-scrollable"
          ></div>
          <div
            class="MuiTabs-scroller MuiTabs-scrollable"
            style={{marginBottom: "0px"}}
          >
            <div aria-label="tabs" class="MuiTabs-flexContainer" role="tablist">
              <a
                class="MuiButtonBase-root MuiTab-root MuiTab-textColorInherit jss24 jss23"
                tabindex="0"
                aria-disabled="false"
                role="tab"
                href="/tickets/attendees"
              >
                <span class="MuiTab-wrapper">General attendees</span>
                <span class="MuiTouchRipple-root"></span>
              </a>
              <a
                class="MuiButtonBase-root MuiTab-root MuiTab-textColorInherit jss24 jss25"
                tabindex="0"
                aria-disabled="false"
                role="tab"
                href="/tickets/group-offers"
              >
                <span class="MuiTab-wrapper">Group offers</span>
                <span class="MuiTouchRipple-root"></span>
              </a>
              <a
                class="MuiButtonBase-root MuiTab-root MuiTab-textColorInherit jss24 jss25"
                tabindex="0"
                aria-disabled="false"
                role="tab"
                href="/tickets/partners"
              >
                <span class="MuiTab-wrapper">Partners</span>
                <span class="MuiTouchRipple-root"></span>
              </a>
              <a
                class="MuiButtonBase-root MuiTab-root MuiTab-textColorInherit jss24 jss25"
                tabindex="0"
                aria-disabled="false"
                role="tab"
                href="/tickets/investors"
              >
                <span class="MuiTab-wrapper">Investors</span>
                <span class="MuiTouchRipple-root"></span>
              </a>
              <a
                class="MuiButtonBase-root MuiTab-root MuiTab-textColorInherit jss24 jss25"
                tabindex="0"
                aria-disabled="false"
                role="tab"
                href="/tickets/startups"
              >
                <span class="MuiTab-wrapper">Startups</span>
                <span class="MuiTouchRipple-root"></span>
              </a>
            </div>
            <span
              class="jss575 jss577 MuiTabs-indicator jss22"
              style={{left: "0px", width: "169.453px"}}
            ></span>
          </div>
        </div>
      </div>
    </header>
    <Attendees/> */}

    {/* <GA/> */}
{/* <GroupOffer/> */}
{/* <Investors/> */}
{/* <Partners/> */}
<Startup/>
    </div>

  );
};

export default Bookings;
